var _ = require('underscore');
var Marionette = require('marionette');
var Dialog = require('Dialog');
var Labels = EY.Consultation.Labels;
var Validation = require('validation');

var Comments = Marionette.View.extend({
    events: {
        'blur @ui.comments': function () { this.model.set('comments', this.ui.comments.val()); },
        'click @ui.recusal': function (e) { this.model.set('recusal', e.target.checked); },
        'click @ui.independence': function (e) { this.model.set('independence', e.target.checked); }
    },
    template: '#dialogApprove',
    ui: {
        acknowledgeContainer: '#acknowledgeContainer',
        comments: '#comments',
        commentContainer: '#commentContainer',
        independence: '#independence',
        independenceContainer: '#independenceContainer',
        message: '#message',
        recusal: '#recusal',
        recusalContainer: '#recusalContainer',
        recusalText: "#recusalText"
    },
    initialize: function () {
        Validation.bind(this);
    },
    onRender: function () {
        var geographyId = this.options.record.get('countryId');

        if (this.model.get("recusal") !== '') {
            this.ui.acknowledgeContainer.removeClass('hidden');
            this.ui.recusalContainer.removeClass('hidden');
            this.ui.recusal.attr('checked', this.model.get("recusal"));
            this.ui.recusalText.html(Labels['Recusal_' + geographyId] || Labels['Recusal']);
        }
        if (this.model.get('independence') !== '') {
            this.ui.acknowledgeContainer.removeClass('hidden');
            this.ui.independenceContainer.removeClass('hidden');
        }
        if (this.model.get("approverGroupId") === 'TeamMember') {
            this.ui.commentContainer.addClass('hidden');
        }
        this.ui.message.html(this.options.message);
    }
});

module.exports.show = function (options) {
    var message = options.message;
    var model = options.model;
    var record = options.record;
    var recusal = model.get('recusal');
    var independence = model.get('independence');
    var allowDisableSave =
        !_.isUndefined(independence) &&
        !_.isUndefined(recusal) &&
        !_.isNull(recusal) &&
        !_.isNull(independence) &&
        recusal !== "" &&
        independence !== "";
    // This attribute is only used for disabling the save button in Dialog.js.
    model.set('disableSave', true);
    model.on('change:recusal change:independence', function () {
        model.set('disableSave', !model.get('recusal') || !model.get('independence'))
    });

    return Dialog.show({
        cancelLabel: Labels.No,
        headerLabel: Labels.DialogTitleWarning,
        saveLabel: Labels.Yes,
        allowDisableSave: allowDisableSave,
        validate: model,
        view: new Comments({
            model: model,
            message: message,
            record: record
        })
    }).always(function () {
        // This attribute is only used for disabling the save button in Dialog.js.
        // It is removed here to prevent it from being passed to the server.
        model.unset('disableSave');
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Dialog/DialogApprove.js